import React, { useEffect, useRef, useState } from 'react'
import OfferAccepted from '../../../../components/HRMS/RecruitmentTracker/OfferAccepted/OfferAccepted';
import { CommonHeader, ErrorSuccessModal } from '../../../../components/commons';
import EditOfferAcceptedCandidate from '../../../../components/HRMS/RecruitmentTracker/HiringCheckList/EditOfferAcceptedCandidate';
import { RootState } from '../../../../redux/rootReducers';
import { connect } from 'react-redux';
import { getSingleRecruitmentTrackerListAction, resetHrmsError, resetHrmsMessage, resetHrmsStatusCode, resetHrmsSuccess, resetRecruitmentTrackerList, resetSingleRecruitmentTrackerList, updateHiringCheckListDataAction } from '../../../../redux/hrms';
import { GetSingleRecruitmentTrackerPayloadType, UpdateHiringCheckListPayloadType } from '../../../../commonTypes/hrmsTypes';
import { BlobServiceClient } from '@azure/storage-blob';
import { ImageDataType } from '../../../../commonTypes/fileManagerTypes';
import { resetSession } from '../../../../redux/auth';
import { FileUploadData, GetGenerateSasTokenPayloadType, UploadFilePayloadType } from '../../../../commonTypes/stcoToolsType';
import { getTokenGenerateForDownloadAction, resetSasTokenForDownloadFile, resetUploadedFiles, uploadFilesAction } from '../../../../redux/stcoTools';

export  type hiringCheckListDataType={
  compDiscussedAndAccepted?:boolean;
  referenceCallFeedbackReceived?:boolean;
  within30DaysCompletedBackgroundCheck?:boolean;
  documentation?:boolean;
  filingUpHRISFormAndLaptopForm?:boolean;
  offerLetterSignature?:boolean;
  finacKnowledge?:boolean;
  holidayList?:boolean;
  emailIDCreation?:boolean;
  hRPolicies?:boolean;
  ptoTool?:boolean;
  stationaryItems?:boolean;
  passBookBankXerox?:boolean;
  payslip?:boolean;
  appointmentLetter?:boolean;
  offerLetter?:boolean;
  relievingLetter?:boolean;
  experienceLetter?:boolean;
  iCAIIntimation?:string;
  employeeCode?:boolean;
  incomeTaxReturn?:boolean;
  fileAttachements?:any;

} 

type AppProps={
  token: string | null;
  success: number | null;
  fetching: boolean;
  error: string | null | undefined;
  message: string | null | undefined;
  statusCode: number | null;
  singleRecruitmentTrackerList: any;
  dispatchUpdateHiringCheckListDataAction:(data:UpdateHiringCheckListPayloadType)=>void;
  dispatchGetSingleRecruitmentTrackerListAction:(data:GetSingleRecruitmentTrackerPayloadType)=>void;
  dispatchResetSession: () => void;
  dispatchResetHrmsSuccess: () => void;
  dispatchResetHrmsMessage: () => void;
  dispatchResetHrmsError: () => void;
  dispatchResetHrmsStatusCode: () => void;
  dispatchResetSingleRecruitmentTrackerList: () => void;
  dispatchResetRecruitmentTrackerList: () => void;
  dispatchUploadFilesAction:(data:UploadFilePayloadType)=>void;
  dispatchResetUploadedFiles:()=>void;
  fileUploadData:FileUploadData[]|[];
  fileUploadFetching:boolean;
  dispatchGetTokenGenerateForDownloadAction:(data:GetGenerateSasTokenPayloadType)=>void;
  dispatchResetSasTokenForDownloadFile:()=>void;
  sasTokenForDownloadFile:string;


}
const HiringCheckList = ({
  token,
  success,
  fetching,
  error,
  message,
  statusCode,
  dispatchUpdateHiringCheckListDataAction,
  dispatchGetSingleRecruitmentTrackerListAction,
  singleRecruitmentTrackerList,
  dispatchResetSession,
  dispatchResetHrmsSuccess,
  dispatchResetHrmsMessage,
  dispatchResetHrmsError,
  dispatchResetHrmsStatusCode,
  dispatchResetSingleRecruitmentTrackerList,
  dispatchResetRecruitmentTrackerList,
  dispatchUploadFilesAction,
  dispatchResetUploadedFiles,
  fileUploadData,
  fileUploadFetching,
  dispatchGetTokenGenerateForDownloadAction,
  dispatchResetSasTokenForDownloadFile,
  sasTokenForDownloadFile

}:AppProps) => {
 
  const [files, setFiles] = useState<any>([]);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [uploadFetching, setUploadFetching] = useState(false);
  const [isOfferAcceptedCandidate, setIsOfferAcceptedCandidate] = useState<boolean>(false);
  const [offerAccepteddata , setOfferAcceptedData]= useState<any>([])
  const [id , setId] = useState("")
  const [uploadFiles, setUploadFiles] = useState<any[]|[]>();

  const [hiringCheckListData , setHiringCheckListData] =useState<hiringCheckListDataType>({
    compDiscussedAndAccepted:false,
    within30DaysCompletedBackgroundCheck:false,
    offerLetterSignature:false,
    documentation:false,
    referenceCallFeedbackReceived:false,
    passBookBankXerox:false,
    payslip:false,
    appointmentLetter:false,
    incomeTaxReturn:false,
    offerLetter:false,
    relievingLetter:false,
    experienceLetter :false,
    iCAIIntimation:"",
    filingUpHRISFormAndLaptopForm:false,
    finacKnowledge:false,
    holidayList:false,
    hRPolicies:false,
    ptoTool:false,
    stationaryItems:false,
    emailIDCreation:false,
    employeeCode:false,
    fileAttachements:[]
  })

  useEffect(() => {
    dispatchResetHrmsSuccess();
    dispatchResetHrmsMessage();
    dispatchResetHrmsError();
    dispatchResetHrmsStatusCode();
    dispatchResetRecruitmentTrackerList();
    dispatchResetUploadedFiles();
    dispatchResetSasTokenForDownloadFile();
    setUploadFiles([])
    // dispatchResetSingleRecruitmentTrackerList();

  }, []);
  const handleEditHiringCheckList =(data:any)=>{
    setIsOfferAcceptedCandidate(true)
    setOfferAcceptedData(data)
    setId(offerAccepteddata?._id)
    if (data?._id && token) {
      const finalData = {
        token,
        id:data?._id,
      };
      dispatchGetSingleRecruitmentTrackerListAction(finalData);
    }


  }


const handleFileClick = () => {
  if (fileInputRef.current) {
    fileInputRef.current.click();
  }
};


  useEffect(()=>{
    if (singleRecruitmentTrackerList && singleRecruitmentTrackerList?.employee_details) {
      setHiringCheckListData((prev: any) => ({
        ...prev,
        compDiscussedAndAccepted: singleRecruitmentTrackerList?.employee_details?.comp_discussed_accepted_email,
        within30DaysCompletedBackgroundCheck: singleRecruitmentTrackerList?.employee_details?.background_check_complete_within_30_days,
        offerLetterSignature: singleRecruitmentTrackerList?.employee_details?.offer_letter_signed,
        documentation: singleRecruitmentTrackerList.employee_details.documentation,
        referenceCallFeedbackReceived: singleRecruitmentTrackerList?.employee_details?.reference_call_feedback_received,
        passBookBankXerox: singleRecruitmentTrackerList?.employee_details?.passbook_bank_statement_xerox,
        payslip: singleRecruitmentTrackerList?.employee_details?.payslip_last_two_months,
        appointmentLetter: singleRecruitmentTrackerList?.employee_details?.appointment_letter_previous_org,
        incomeTaxReturn: singleRecruitmentTrackerList?.employee_details?.income_tax_return, 
        offerLetter: singleRecruitmentTrackerList?.employee_details?.offer_letter_previous_org,
        relievingLetter: singleRecruitmentTrackerList?.employee_details?.relieving_letter_previous_org,
        experienceLetter: singleRecruitmentTrackerList?.employee_details?.experience_letter_previous_org,
        iCAIIntimation: singleRecruitmentTrackerList?.employee_details?.icai_intimation,
        filingUpHRISFormAndLaptopForm: (singleRecruitmentTrackerList?.employee_details?.hris_form_filled && singleRecruitmentTrackerList?.employee_details?.laptop_form_filled),
        finacKnowledge: singleRecruitmentTrackerList?.employee_details?.finac_knowledge,
        holidayList: singleRecruitmentTrackerList?.employee_details?.holiday_list ,
        hRPolicies: singleRecruitmentTrackerList?.employee_details?.hr_policies,
        ptoTool: singleRecruitmentTrackerList?.employee_details?.pto_tool ,
        stationaryItems: singleRecruitmentTrackerList?.employee_details?.stationary_items,
        emailIDCreation: singleRecruitmentTrackerList?.employee_details?.email_id_creation ,
        employeeCode: singleRecruitmentTrackerList?.employee_details?.employee_code,
        fileAttachements:singleRecruitmentTrackerList?.employee_details?.file_attachment

      }));
      setUploadFiles(singleRecruitmentTrackerList?.employee_details?.file_attachment)

    }
    
    
  },[singleRecruitmentTrackerList])


  
  useEffect(() => {
    if (fileUploadData?.length) {
      setUploadFiles((prevFiles: any) => {
        return Array.isArray(prevFiles) ? [...prevFiles, ...fileUploadData] : [...fileUploadData];
      });
    }
  }, [fileUploadData]);
  

  const handleToggleAllItems = (name:string) => {
    
    setHiringCheckListData((prevState:any) => ({
      ...prevState,
      [name]: !prevState[name]
    }));
  };
  
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const filesArray = Array.from(files); 
      const oversizedFile = filesArray.find((file) => file.size > 5 * 1024 * 1024);
     

     
      dispatchUploadFilesAction({ token, files: filesArray ,containerType:2
      }); 
    }
  
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; 
    }
  };

  const handleICAIIntimation = (event:any) => {
    const { value } = event.target;
    setHiringCheckListData(prevState => ({
      ...prevState,
      iCAIIntimation: value
    }));
  };



  const handleUpdateHiringCheckListData =(data:any)=>{
    let fileData = JSON.parse(JSON.stringify(hiringCheckListData))
    fileData["fileAttachements"]= uploadFiles
    setHiringCheckListData(fileData)
    let finalData ={
      token,
      id:offerAccepteddata?._id,
      hiringCheckListData:fileData
    }
    dispatchUpdateHiringCheckListDataAction(finalData)
    setIsOfferAcceptedCandidate(false)


  }
  const toggleOfferAcceptedCandidate =()=>{
    setIsOfferAcceptedCandidate(false)
    
  }

  const handleDeleteUploadedFile = (indexToDelete: number) => {
  
    const filteredFiles = uploadFiles?.filter((_:any, i:any) => i !== indexToDelete);
    setUploadFiles(filteredFiles);   
  };
  
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetHrmsError();
            }}
          />
        );
      }
    }

 
  };

  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <CommonHeader title="Hiring Checklist" />
        </div>
      </div>
      <OfferAccepted type="hiringCheckList" handleEditHiringCheckList={handleEditHiringCheckList}/>

      { <EditOfferAcceptedCandidate 
        isRight={true}
        isOpen ={isOfferAcceptedCandidate}
        offerAccepteddata={offerAccepteddata}
        onClose ={toggleOfferAcceptedCandidate}
        hiringCheckListData={hiringCheckListData}
        handleToggleAllItems={handleToggleAllItems}
        handleUpdateHiringCheckListData={handleUpdateHiringCheckListData}
        fetching={fetching}
        handleICAIIntimation={handleICAIIntimation}
        uploadFetching={uploadFetching}
        uploadFiles={uploadFiles}
        files={files}
        handleDeleteUploadedFile={handleDeleteUploadedFile}
        handleFileChange={handleFileChange}
        fileInputRef={fileInputRef}
        handleFileClick={handleFileClick}

      />
      }
            {handleErrorModal()}

    </>
  )
}

const mapStateTopProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.hrms.addEditFetching,
  success: state.hrms.success,
  statusCode: state.hrms.statusCode,
  error: state.hrms.error,
  message: state.hrms.message,
  singleRecruitmentTrackerList: state.hrms.singleRecruitmentTrackerList,
  fileUploadData:state.stcoTools.fileUploadData,
  fileUploadFetching:state.stcoTools.fileUploadFetching,
  sasTokenForDownloadFile: state.stcoTools.sasTokenForDownloadFile,


});
const mapDispatchToProps =(dispatch:any)=>({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetHrmsSuccess: () => dispatch(resetHrmsSuccess()),
  dispatchResetHrmsMessage: () => dispatch(resetHrmsMessage()),
  dispatchResetHrmsError: () => dispatch(resetHrmsError()),
  dispatchResetHrmsStatusCode: () => dispatch(resetHrmsStatusCode()),

  dispatchUpdateHiringCheckListDataAction: (
    data: UpdateHiringCheckListPayloadType
  ) => dispatch(updateHiringCheckListDataAction(data)),
  dispatchGetSingleRecruitmentTrackerListAction: (
    data: GetSingleRecruitmentTrackerPayloadType
  ) => dispatch(getSingleRecruitmentTrackerListAction(data)),
  dispatchResetSingleRecruitmentTrackerList: () =>
    dispatch(resetSingleRecruitmentTrackerList()),
  dispatchResetRecruitmentTrackerList: () =>
    dispatch(resetRecruitmentTrackerList()),
    dispatchUploadFilesAction: (data: UploadFilePayloadType) =>
      dispatch(uploadFilesAction(data)),
    dispatchResetUploadedFiles:()=>dispatch(resetUploadedFiles()),
      dispatchGetTokenGenerateForDownloadAction: (data: GetGenerateSasTokenPayloadType) =>
        dispatch(getTokenGenerateForDownloadAction(data)),
      dispatchResetSasTokenForDownloadFile: () =>
        dispatch(resetSasTokenForDownloadFile()),

})
export default connect(mapStateTopProps, mapDispatchToProps)(HiringCheckList);

